module.exports = __webpack_public_path__ + "static/media/SelectedBulbRed.87d08098.svg";